module.exports = __webpack_public_path__ + "img/logo.d9149a29.svg";